<div class="riport-wrap">
  <!-- Riporttípus választó -->
  <div class="tipus-sav">
    <ion-chip *ngFor="let t of tipusok" [outline]="aktivTipus !== t.tipus"
              [color]="aktivTipus === t.tipus ? 'primary' : 'medium'" (click)="valasztTipus(t.tipus)">
      <ion-label>{{ t.cim }}</ion-label>
    </ion-chip>
  </div>

  <!-- Szűrő + export -->
  <ion-card class="szuro-kartya">
    <ion-card-content>
      <div class="szuro-sor">
        <ion-item lines="none">
          <ion-label position="stacked">Időszak kezdete</ion-label>
          <ion-input type="date" [(ngModel)]="tol" (ionChange)="betolt()"></ion-input>
        </ion-item>
        <ion-item lines="none">
          <ion-label position="stacked">Időszak vége</ion-label>
          <ion-input type="date" [(ngModel)]="ig" (ionChange)="betolt()"></ion-input>
        </ion-item>
        <div class="export-gombok">
          <ion-button fill="outline" size="small" (click)="export('xlsx')" [disabled]="!!exportFolyamatban || !adat">
            <ion-icon slot="start" name="grid-outline"></ion-icon>
            <ion-spinner *ngIf="exportFolyamatban === 'xlsx'" name="dots"></ion-spinner>
            <span *ngIf="exportFolyamatban !== 'xlsx'">Excel</span>
          </ion-button>
          <ion-button fill="outline" size="small" color="danger" (click)="export('pdf')" [disabled]="!!exportFolyamatban || !adat">
            <ion-icon slot="start" name="document-outline"></ion-icon>
            <ion-spinner *ngIf="exportFolyamatban === 'pdf'" name="dots"></ion-spinner>
            <span *ngIf="exportFolyamatban !== 'pdf'">PDF</span>
          </ion-button>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <div *ngIf="betoltes" class="kozepre"><ion-spinner></ion-spinner></div>

  <ng-container *ngIf="!betoltes && adat">
    <!-- Összesítő kártyák -->
    <div class="ossz-sav" *ngIf="adat.osszesites?.length">
      <ion-card class="ossz-kartya" *ngFor="let o of adat.osszesites">
        <ion-card-content>
          <div class="ossz-cimke">{{ o.label }}</div>
          <div class="ossz-ertek">{{ ossz(o) }}</div>
        </ion-card-content>
      </ion-card>
    </div>

    <!-- Táblázat -->
    <div class="tabla-wrap">
      <table class="riport-tabla">
        <thead>
          <tr>
            <th *ngFor="let o of adat.oszlopok">{{ o.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sor of adat.sorok">
            <td *ngFor="let o of adat.oszlopok" [class.penz]="o.tipus === 'penz'" [class.kozep]="o.tipus === 'datum' || o.tipus === 'bool'">
              {{ cella(sor, o) }}
            </td>
          </tr>
          <tr *ngIf="!adat.sorok.length">
            <td [attr.colspan]="adat.oszlopok.length" class="ures">Nincs tétel a megadott időszakra.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
